import module from 'colaborador/module.js'
import template from './template.html'

export class ColaboradorPrestamosExternosAgregarComponent {
  idProyecto
  idColaborador
  procesando = false
  error = null
  personaId = null

  data = {
    conceptoId: undefined,
    descripcion: null,
    fechaInicial: new Date(),
    importe: null,
    plazos: 3,
  }
  conceptosPrestamo = [
    { id: 1, descripcion: 'Descuento Nueva Farmacia' },
    { id: 2, descripcion: 'Descuento Algodoneros' },
  ]

  constructor(ColaboradorPrestamosExternos, CatalogoColaboradorPersona, $state) {
    this.ColaboradorPrestamosExternos = ColaboradorPrestamosExternos
    this.CatalogoColaboradorPersonaService = CatalogoColaboradorPersona
    this.$state = $state
  }

  $onInit () {
    this.promise = this.CatalogoColaboradorPersonaService.get(this.idProyecto, this.idColaborador)
      .then(({ data }) => (this.personaId = data.personaId))
  }

  guardar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    let manual = true
    this.ColaboradorPrestamosExternos.post(this.idProyecto, this.idColaborador, this.personaId, manual, this.data)
      .then(() => (this.$state.reload()))
      .catch((error) => (this.error = error.data || error))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.onClose()
  }

  obtenerDescripcion () {
    let concepto = this.conceptosPrestamo.find(elemento => elemento.id === this.data.conceptoId)

    if (concepto) {
      this.data.descripcion = concepto.descripcion
    }
  }
}

module.component('colaboradorPrestamosExternosAgregar', {
  controller: ColaboradorPrestamosExternosAgregarComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/colaborador/components/prestamosExternos/agregar/component.js